// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"fe528a34","63":"75ea4e73","115":"61f88511","122":"30f03aab","143":"7104c82d","334":"c0e06098","385":"3db18f6e","447":"6ac0aa8d","535":"af310353","953":"58736ec7"}[chunkId] + ".chunk.js";
};